import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  endDateValidationRule,
  requiredDateRule,
  requiredStartDate,
} from "../../../../utils/validationUtils";

export const flyerCreateFormValidation = yupResolver(
  yup.object({
    name: yup
      .string()
      .required("Design Layout Name is required.")
      .max(256, "Design Layout Name must be under 256 characters."),
    startAt: requiredStartDate,
    endAt: endDateValidationRule,
    wtwReviewDate: requiredDateRule("Please enter a WTW Review Date."),
    wtwSeniorReviewDate: requiredDateRule("Please enter a WTW Senior Review Date."),
  })
);
